/* eslint-disable max-len */
import React from 'react';

export const Products: React.FC = () => (
    <svg
        width="504"
        height="220"
        viewBox="0 0 504 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_d_1383:685)">
            <g clipPath="url(#clip0_1383:685)">
                <rect x="40" y="40" width="404" height="120" rx="16" />
                <g opacity="0.3" clipPath="url(#clip1_1383:685)">
                    <path
                        d="M361.589 109.744L358.655 100.941H317.324L315.883 82.9336V68H288.432V82.9336L285.755 116.394L276.079 138.511V196.332C276.079 202.766 281.313 208 287.747 208H316.568C317.762 208 318.915 207.819 320.001 207.484V208H340.633C346.663 208 351.569 203.094 351.569 197.063V176.449C351.569 165.4 354.181 154.337 359.123 144.454C362.263 138.174 363.922 131.143 363.922 124.121C363.922 119.226 363.137 114.389 361.589 109.744ZM352.719 109.176L353.776 112.348C354.77 115.329 355.374 118.408 355.591 121.529H321.373L318.56 116.394L317.982 109.176H352.719ZM320.001 183.294H284.314V150.353H320.001V183.294ZM296.667 76.2353H307.648V83.098L307.757 84.4706H296.571L296.667 83.2625V76.2353ZM293.854 118.429L295.912 92.7059H308.413L310.461 118.429L320.001 140.234V142.118H284.314V140.234L293.854 118.429ZM316.568 199.765H287.747C285.854 199.765 284.314 198.225 284.314 196.332V191.529H320.001V196.332C320.001 198.225 318.461 199.765 316.568 199.765ZM343.334 176.449V197.063C343.334 198.553 342.122 199.765 340.633 199.765H327.72C328.055 198.679 328.236 197.526 328.236 196.332V138.511L324.409 129.765H355.25C354.661 133.585 353.483 137.317 351.757 140.771C346.246 151.791 343.334 164.129 343.334 176.449Z"
                        fill="#F2994A"
                    />
                </g>
                <g opacity="0.3">
                    <path
                        d="M241.945 6.05501C220.054 5.51575 193.103 8.86876 173.779 19.3341C164.315 11.7853 149.623 12.8724 141.648 23.5044L118.908 53.8247L137.229 65.4324C134.941 72.7786 133.83 80.7287 135.069 88.26C127.82 85.7995 119.509 87.4485 113.726 93.2302L102 104.957L110.795 113.752C115.427 118.383 121.858 120.532 128.384 119.616C127.469 126.129 129.608 132.564 134.248 137.205L143.043 146L154.769 134.273C160.535 128.508 162.206 120.198 159.74 112.933C168.534 114.378 177.928 112.62 186.243 109.514L197.78 127.098L228.043 104.4C239.306 95.9525 239.94 79.8533 230.58 70.4361C239.494 51.5925 242.454 26.7256 241.945 6.05501ZM130.924 51.6221L148.282 28.4794C152.618 22.6979 160.18 21.3281 166.053 24.2123C157.283 30.6723 146.416 43.5968 140.225 57.5144L130.924 51.6221ZM116.658 107.889L113.726 104.957L119.59 99.0938C124.451 94.2325 132.318 94.2325 137.18 99.0938L140.112 102.025L134.248 107.889C129.396 112.74 121.53 112.759 116.658 107.889ZM148.906 128.41L143.043 134.273L140.112 131.342C135.25 126.48 135.25 118.614 140.112 113.752L145.975 107.889L148.906 110.82C153.766 115.68 153.768 123.548 148.906 128.41ZM176.455 103.862C152.395 109.618 138.372 95.6449 144.138 71.5444C147.097 59.1777 154.754 46.3387 165.701 35.3921C169.037 32.056 172.991 29.2472 177.301 26.8776C178.179 50.6433 197.331 69.8205 221.121 70.7003C218.753 75.0091 215.944 78.963 212.607 82.2992C201.661 93.2452 188.822 100.903 176.455 103.862ZM223.068 97.7671L199.869 115.166L193.946 106.138C202.562 101.8 210.951 95.6816 218.47 88.1627C221.336 85.297 223.951 81.9841 226.315 78.2405C230.438 84.2508 229.472 92.963 223.068 97.7671ZM225.022 62.3776C202.754 63.6668 184.332 45.2411 185.623 22.9782C203.813 15.7254 225.016 14.4614 233.737 14.2635C233.538 22.9862 232.274 44.1886 225.022 62.3776Z"
                        fill="#F2994A"
                    />
                    <path
                        d="M206.989 35.1427L212.852 29.2803L218.714 35.1427L212.852 41.0051L206.989 35.1427Z"
                        fill="#F2994A"
                    />
                    <path
                        d="M183.689 68.4626L183.983 63.7713L179.292 64.0654C175.478 64.2986 173.409 59.6875 176.098 56.9978L170.234 51.1345C163.435 57.9342 166.658 69.4914 175.812 71.9422C178.301 81.2378 189.892 84.2467 196.619 77.5194L190.756 71.6561C188.048 74.3638 183.451 72.2523 183.689 68.4626Z"
                        fill="#F2994A"
                    />
                </g>
            </g>
        </g>
        <defs>
            <filter
                id="filter0_d_1383:685"
                x="0"
                y="0"
                width="504"
                height="220"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="10" dy="10" />
                <feGaussianBlur stdDeviation="25" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.560784 0 0 0 0 0.823529 0 0 0 0 0.952941 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1383:685"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1383:685"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0_1383:685">
                <rect x="40" y="40" width="404" height="120" rx="16" />
            </clipPath>
            <clipPath id="clip1_1383:685">
                <rect width="140" height="140" transform="translate(250 68)" />
            </clipPath>
        </defs>
    </svg>
);
